<template>
  <div id="wave">
    <span class="dot" :class="'bg-' + variant"></span>
    <span class="dot" :class="'bg-' + variant"></span>
    <span class="dot" :class="'bg-' + variant"></span>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: function (value) {
        // The value must match one of these strings
        return ['success', 'warning', 'danger', 'primary', 'secondary', 'info', 'dark', 'white'].includes(value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
div#wave {
  display: inline-block;
  position: relative;
  text-align: center;
  width: auto;
  .dot {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    margin-right: 3px;
    background: $dark;
    animation: wave 1.3s linear infinite;

    &:nth-child(2) {
      animation-delay: -1.1s;
    }

    &:nth-child(3) {
      animation-delay: -0.9s;
    }
  }
}

@keyframes wave {
  0%,
  60%,
  100% {
    transform: initial;
  }

  30% {
    transform: translateY(-15px);
  }
}
</style>
